export default "__VITE_PUBLIC_ASSET__4e9a1756__"